import {
  FileLocalUrl,
} from 'pages/Dashboard/components/FilePicker';
import {
  imageToPdf,
  normalizeToDataUrl,
} from 'utils/files';

export default async function convertImageSourcesToPdf(sources: string[]): Promise<FileLocalUrl> {
  const normalized = await Promise.all((sources ?? []).map((source) => normalizeToDataUrl(source)));
  return imageToPdf(normalized);
}
